import {functionalityToggleActions} from '@/store/modules/functionality-toggle.js';
import {useStore} from '@/store';
import {onMounted, ref} from 'vue';

export function useFunctionalityToggle(toggleId) {
  const isToggleActive = ref(false);
  const store = useStore();

  onMounted(async () => {
    try {
      const toggle = await store.dispatch(functionalityToggleActions.GET_TOGGLE_BY_ID, toggleId);
      isToggleActive.value = toggle?.active;
    } catch (error) {
      console.error('Failed to fetch toggle configuration', toggleId, error);
    }
  });

  return {isToggleActive};
}
